import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { info } from 'octicons';
import { LocalStorageService, ObjetsService } from '../../shared';

@Component({
  selector: 'app-form-g',
  templateUrl: './app-form-g.component.html',
  providers: [ObjetsService],
  styleUrls: ['./app-form-g.component.scss']
})
export class AppFormGComponent implements OnInit {
  @Output() personsChanged = new EventEmitter<void>();
  public formName = 'rubrique_G_acquereur';
  public metaData: any = [];
  public alive = true;
  public datas: any = [];

  /**
   * Liste des professions. Alimentée de l'extérieur par form-dia.
   * Le setter re-synchronise les selects profession après que les options sont rendues.
   */
  private _datasProf: any = [];
  get datasProf() { return this._datasProf; }
  set datasProf(value: any) {
    this._datasProf = value;
    if (value && value.length > 0) {
      // Après que Angular a rendu les options, forcer la re-synchronisation
      // des selects profession dont la valeur a été patchée avant l'arrivée des données
      setTimeout(() => {
        const ppControls = this.personnePhysiqueData.controls;
        for (let i = 0; i < ppControls.length; i++) {
          const currentValue = ppControls[i].get('profession').value;
          if (currentValue && currentValue.code) {
            ppControls[i].get('profession').setValue(currentValue, { emitEvent: false });
          }
        }
      });
    }
  }

  public hiddenPersonPp: any = [];
  public showPersonLinePp: any = [];
  public hiddenPersonPm: any = [];
  public showPersonLinePm: any = [];
  public formTooltip: any = [];
  public personneValid = false;
  public errorMessagePm = true;
  public errorMessagePp = true;
  public infoIcon: SafeHtml;

  public listeCommunes: Map<string, string[]>;
  public listLieuxDitsCp = new Map;

  private lineIndexPp = 0;
  private lineIndexPm = 0;

  country: any = [];

  acquereur: FormGroup;
  personnePhysique: FormGroup;
  personneMorale: FormGroup;

  items: FormArray;
  itemsPp: FormArray;
  itemsPm: FormArray;

  constructor(
    private _objetsService: ObjetsService,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService
  ) {
    this.personnePhysique = new FormGroup({
      nom: new FormControl('', Validators.required),
      prenom: new FormControl('', Validators.required),
      nom_usage: new FormControl(),
      profession: new FormGroup({
        code: new FormControl(),
        lib: new FormControl()
      }),
      adresse_boite_aux_lettres: new FormControl(),
      adresse_entree: new FormControl(),
      adresse_numero: new FormControl(),
      adresse_extension: new FormControl(),
      adresse_nom_voie: new FormControl(),
      adresse_type_voie: new FormControl(),
      adresse_lieu_dit_bp: new FormControl(),
      adresse_bp: new FormControl(),
      adresse_cp: new FormControl('', Validators.required),
      adresse_localite: new FormControl('', Validators.required),
      adresse_cedex: new FormControl(),
      adresse_state: new FormControl(),
      adresse_country: new FormControl('', Validators.required),
      adresse_code_origine: new FormControl(''),
      adresse_telephone: new FormControl(),
      adresse_indicatif: new FormControl(),
      adresse_email: new FormControl('')
    });

    this.personneMorale = new FormGroup({
      denomination: new FormControl('', Validators.required),
      forme_juridique: new FormControl('', Validators.required),
      siret: new FormControl('', Validators.pattern(/^$|^\d{14}$/)),
      nom: new FormControl('', Validators.required),
      prenom: new FormControl('', Validators.required),
      adresse_boite_aux_lettres: new FormControl(),
      adresse_entree: new FormControl(),
      adresse_numero: new FormControl(),
      adresse_extension: new FormControl(),
      adresse_nom_voie: new FormControl(),
      adresse_type_voie: new FormControl(),
      adresse_lieu_dit_bp: new FormControl(),
      adresse_bp: new FormControl(),
      adresse_cp: new FormControl('', Validators.required),
      adresse_localite: new FormControl('', Validators.required),
      adresse_cedex: new FormControl(),
      adresse_state: new FormControl(),
      adresse_country: new FormControl('', Validators.required),
      adresse_code_origine: new FormControl(''),
      adresse_telephone: new FormControl(),
      adresse_indicatif: new FormControl(),
      adresse_email: new FormControl('')
    });

    this.acquereur = new FormGroup({
      g_acquereur: new FormControl(),
    });

    this.acquereur = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem('') ])
    });

    this.personnePhysique = this.formBuilder.group({
      itemsPp: this.formBuilder.array([ this.createItem('pp') ])
    });

    this.personneMorale = this.formBuilder.group({
      itemsPm: this.formBuilder.array([ this.createItem('pm') ])
    });
  }

  get acquereurData() { return <FormArray>this.acquereur.get('items'); }
  get personnePhysiqueData() { return <FormArray>this.personnePhysique.get('itemsPp'); }
  get personneMoraleData() { return <FormArray>this.personneMorale.get('itemsPm'); }

  ngOnInit (): void {
    this.country = Object.keys(this._objetsService.getCountry()).map(key => ({type: key, value: this._objetsService.getCountry()[key]}));

    this.infoIcon = this.sanitizer.bypassSecurityTrustHtml(info.toSVG());
    this.getTooltip();

    this.showPersonLinePp[0] = true;
    this.showPersonLinePm[0] = true;

    this.hiddenPersonPp[0] = true;
    this.hiddenPersonPm[0] = true;

    this.restorePersonsFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.personnePhysique.valueChanges.subscribe(() => this.savePersonsToStorage());
    this.personneMorale.valueChanges.subscribe(() => this.savePersonsToStorage());
  }

  /**
   * Ajoute une personne
   *
   * @param i
   * @param type
   */
  addItem(i, type): void {
    if (this.personneValid === true) {
      if (type === 'pp') {
        this.lineIndexPp = this.lineIndexPp + 1;
        this.showPersonLinePp[this.lineIndexPp] = true;

        this.itemsPp = this.personnePhysique.get('itemsPp') as FormArray;
        this.itemsPp.push(this.createItem('pp'));

        this.hiddenPersonPp[i] = true;
        this.showPersonLinePp[i] = false;
        this.hiddenPersonPp[this.lineIndexPp] = true;

      } else if (type === 'pm') {
        this.lineIndexPm = this.lineIndexPm + 1;
        this.showPersonLinePm[this.lineIndexPm] = true;

        this.itemsPm = this.personneMorale.get('itemsPm') as FormArray;
        this.itemsPm.push(this.createItem('pm'));

        this.hiddenPersonPm[i] = true;
        this.showPersonLinePm[i] = false;
        this.hiddenPersonPm[this.lineIndexPm] = true;
      }
      this.personneValid = false;
    }

    this.savePersonsToStorage();
    this.personsChanged.emit();
  }

  /**
   * Affiche le formulaire d'une personne quand on clique sur une ligne de la liste
   *
   * @param i
   * @param type
   */
  showPerson(i, type): void {
    if (type === 'pp')  {
      if (this.hiddenPersonPp[i]) {
        this.hiddenPersonPp[i] = false;
      } else {
        this.hiddenPersonPp[i] = true;
      }
    } else if (type === 'pm') {
      if (this.hiddenPersonPm[i]) {
        this.hiddenPersonPm[i] = false;
      } else {
        this.hiddenPersonPm[i] = true;
      }
    }

    this.savePersonsToStorage();
  }

  /**
   * Valide le formulaire de la personne morale avant de replier la ligne.
   * Si le formulaire est invalide, affiche les erreurs et ne replie pas.
   */
  validateAndSavePerson(i, type): void {
    const typePerson = type === 'pm' ? 'morale' : 'physique';
    this.checkPersonneValidity(typePerson);
    if (type === 'pm' && !this.personneMorale.valid) {
      return;
    }
    if (type === 'pp' && !this.personnePhysique.valid) {
      return;
    }
    this.showPerson(i, type);
  }

  /**
   * Supprime une personne physique ou morale de la liste des personne grâce au bouton "Supprimer"
   *
   * @param i
   * @param type
   */
  deletePerson(i, type): void {
    if (type === 'pp')  {
      this.hiddenPersonPp.splice(i, 1);
      this.itemsPp.removeAt(i);
      this.lineIndexPp = this.lineIndexPp - 1;
      this.showPersonLinePp[this.lineIndexPp] = true;
    } else if (type === 'pm') {
      this.hiddenPersonPm.splice(i, 1);
      this.itemsPm.removeAt(i);
      this.lineIndexPm = this.lineIndexPm - 1;
      this.showPersonLinePm[this.lineIndexPm] = true;
    }

    this.savePersonsToStorage();
    this.personsChanged.emit();
  }

  /**
   * Pilote l'affichage du formulaire d'ajout d'une personne physique ou morale
   *
   * @param type
   */
  getAddForm(type): void {
    if (type === 'pp')  {
      if (this.hiddenPersonPp[this.lineIndexPp] === false) {
        this.hiddenPersonPp[this.lineIndexPp] = true;
      } else {
        this.hiddenPersonPp[this.lineIndexPp] = false;
      }
    } else if (type === 'pm') {
      if (this.hiddenPersonPm[this.lineIndexPp] === false) {
        this.hiddenPersonPm[this.lineIndexPm] = true;
      } else {
        this.hiddenPersonPm[this.lineIndexPm] = false;
      }
    }

    this.savePersonsToStorage();
  }

  /**
   * Créé le formgroup pour le formarray
   *
   * @param type
   * @returns {FormGroup}
   */
  createItem(type): FormGroup {
    if (type === 'pp')  {
      const group = this.formBuilder.group({
        nom: '',
        prenom: '',
        nom_usage: '',
        profession: {},
        adresse_boite_aux_lettres: '',
        adresse_entree: '',
        adresse_numero: '',
        adresse_extension: '',
        adresse_nom_voie: '',
        adresse_type_voie: '',
        adresse_lieu_dit_bp: '',
        adresse_bp: '',
        adresse_cp: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]],
        adresse_localite: '',
        adresse_cedex: ['', [Validators.min(1), Validators.max(99)]],
        adresse_state: '',
        adresse_country: 'FR',
        adresse_code_origine: '',
        adresse_telephone: '',
        adresse_indicatif: '',
        adresse_email: ''
      });
      this.setupCpLogic(group, 'adresse_country', 'adresse_cp');
      return group;
    } else if (type === 'pm') {
      const group = this.formBuilder.group({
        denomination: '',
        forme_juridique: '',
        siret: ['', [Validators.required, Validators.pattern(/^\d{14}$/)]],
        nom: '',
        prenom: '',
        adresse_boite_aux_lettres: '',
        adresse_entree: '',
        adresse_numero: '',
        adresse_extension: '',
        adresse_nom_voie: '',
        adresse_type_voie: '',
        adresse_lieu_dit_bp: '',
        adresse_bp: '',
        adresse_cp: ['', [Validators.required, Validators.pattern(/^\d{5}$/)]],
        adresse_localite: '',
        adresse_cedex: ['', [Validators.min(1), Validators.max(99)]],
        adresse_state: '',
        adresse_country: 'FR',
        adresse_code_origine: '',
        adresse_telephone: '',
        adresse_indicatif: '',
        adresse_email: ''
      });
      this.setupCpLogic(group, 'adresse_country', 'adresse_cp');
      return group;
    } else {
      return this.formBuilder.group({
        g_acquereur: false,
      });
    }
  }

  public getListLieuxDit(i: number, type: string): void {
    let selectedCp: number;
    const mapKey = type + '_' + i.toString();
    if (type === 'pp') {
      selectedCp = this.personnePhysiqueData.get(i.toString()).get('adresse_cp').value;
    }
    if (type === 'pm') {
      selectedCp = this.personneMoraleData.get(i.toString()).get('adresse_cp').value;
    }

    if (selectedCp.toString().substring(0, 2) === '34') {
      this.listLieuxDitsCp.set(mapKey, this.listeCommunes.get(selectedCp.toString()));
    } else {
      this.listLieuxDitsCp.set(mapKey, undefined);
    }
  }

  /**
   * Function mettant à jour les variables pilotant les messages d'erreur en cas d'invalidité du formulaire de personnePhysique ou morale,
   * et ceci au moment ou l'utilisatuer appuie sur le bouton Enregistrer
   *
   * @param type
   */
  checkPersonneValidity(type): void {
    let valid;

    if (type === 'physique') {
      valid = this.personnePhysique.valid;
    } else if (type === 'morale') {
      valid = this.personneMorale.valid;
    }

    if (valid) {
      this.personneValid = true;
      if (type === 'physique') {
        this.errorMessagePp = true;
      } else if (type === 'morale') {
        this.errorMessagePm = true;
      }
    } else {
      if (type === 'physique') {
        this.errorMessagePp = false;
      } else if (type === 'morale') {
        this.errorMessagePm = false;
      }
    }
  }

  /**
   * Fonction gérant l'affichage des messages de non validités des champs ainsi que la classe associée à cette dernière
   *
   * @param dirty
   * @param typePerson
   * @param {string} type
   * @returns {any}
   */
  checkFieldValidity(dirty, typePerson, type = 'validity'): any {
    const valid = this.showErrorMessage(typePerson);

    switch (type) {
      case 'class':
        if (!valid && !dirty) {
          return 'is-invalid';
        } else {
          return '';
        }
      default:
        if (!valid && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  /**
   * Renvoit un boolean en fonction de la validité des formulaires présent dans l'étape courante
   *
   * @param type
   * @returns {boolean}
   */
  showErrorMessage(type): boolean {
    if (type === 'physique' && this.personneValid === false) {
      return this.errorMessagePp;
    } else if (type === 'morale' && this.personneValid === false) {
      return this.errorMessagePm;
    } else {
      return true;
    }
  }

  /**
   * Met à jour la variable formTooltip qui est utilisé pour mettre à jour le contenu des tooltips
   */
  getTooltip(): void {
    this.formTooltip = [
      {text:'Les renseignements concernant l’acquéreur doivent être obligatoirement fournis si la personne ' +
        'qui se propose d’acquérir l’immeuble l’exige'},
      {text:'Maintien de l’usage actuel ou, au contraire, changement de cet usage, ' +
        'par exemple, conversion de bureaux en logements. Vous pouvez préciser également ' +
        'les conditions dans lesquelles l’acquéreur envisage de conférer cette destination au bien :' +
        ' en le laissant en l’état, en le réhabilitant, en édifiant une construction neuve, etc.'},
    ];
  }

  isButtonsDisabled(): Boolean {
    const length = this.personnePhysiqueData.controls.length + this.personneMoraleData.controls.length;
    // 1 personne max (PP ou PM). Il y a forcément une entrée d'avance dans chaque tableau ;
    // qui est RAZ à l'ajout (pour le formulaire vide), d'où le threshold à une longueur de 3
    if(length > 2) {
      return true;
    } else {
      return null;
    }
  }

  /**
   * Comparateur pour la select box profession :
   * compare par code pour éviter les problèmes de référence après désérialisation JSON.
   */
  compareProfession(a: any, b: any): boolean {
    if (!a || !b) { return a === b; }
    return a.code === b.code;
  }

  /**
   * Sauvegarde les personnes physiques et morales enregistrées dans le localStorage.
   * Exclut la dernière entrée vide (formulaire d'ajout).
   */
  private savePersonsToStorage(): void {
    const ppControls = this.personnePhysiqueData.controls;
    const ppValues = [];
    for (let i = 0; i < ppControls.length - 1; i++) {
      ppValues.push(ppControls[i].value);
    }

    const pmControls = this.personneMoraleData.controls;
    const pmValues = [];
    for (let i = 0; i < pmControls.length - 1; i++) {
      pmValues.push(pmControls[i].value);
    }

    const ppFormOpen = this.hiddenPersonPp[this.lineIndexPp] === false;
    const pmFormOpen = this.hiddenPersonPm[this.lineIndexPm] === false;

    this.localStorageService.save('form_g', {
      pp: ppValues,
      pm: pmValues,
      ppFormOpen,
      pmFormOpen,
      currentPpForm: ppFormOpen ? this.personnePhysiqueData.at(this.lineIndexPp).value : null,
      currentPmForm: pmFormOpen ? this.personneMoraleData.at(this.lineIndexPm).value : null
    });
  }

  /**
   * Restaure les personnes physiques et morales depuis le localStorage.
   * Reconstruit les FormArrays et les tableaux d'affichage.
   */
  private restorePersonsFromStorage(): void {
    const saved = this.localStorageService.load('form_g');
    if (!saved) { return; }

    const savedPp: any[] = saved.pp;
    if (savedPp && savedPp.length > 0) {
      // RAZ du FormArray PP
      while (this.personnePhysiqueData.length > 0) {
        this.personnePhysiqueData.removeAt(0);
      }
      this.hiddenPersonPp = [];
      this.showPersonLinePp = [];

      // Pousser la première entrée
      const firstPp = this.createItem('pp');
      this.personnePhysiqueData.push(firstPp);
      this.personnePhysiqueData.at(0).patchValue(savedPp[0], { emitEvent: false });
      this.hiddenPersonPp[0] = true;
      this.showPersonLinePp[0] = false;

      // Ajouter les personnes suivantes
      for (let i = 1; i < savedPp.length; i++) {
        const group = this.createItem('pp');
        this.personnePhysiqueData.push(group);
        this.personnePhysiqueData.at(i).patchValue(savedPp[i], { emitEvent: false });
        this.hiddenPersonPp[i] = true;
        this.showPersonLinePp[i] = false;
      }

      // Ajouter l'entrée vide pour le prochain ajout
      const emptyPp = this.createItem('pp');
      this.personnePhysiqueData.push(emptyPp);
      this.lineIndexPp = savedPp.length;
      this.hiddenPersonPp[this.lineIndexPp] = true;
      this.showPersonLinePp[this.lineIndexPp] = true;
      this.itemsPp = this.personnePhysiqueData;
    }

    // Restaurer le brouillon du formulaire PP si ouvert
    if (saved.ppFormOpen) {
      this.hiddenPersonPp[this.lineIndexPp] = false;
      if (saved.currentPpForm) {
        this.personnePhysiqueData.at(this.lineIndexPp).patchValue(saved.currentPpForm, { emitEvent: false });
      }
    }

    const savedPm: any[] = saved.pm;
    if (savedPm && savedPm.length > 0) {
      // RAZ du FormArray PM
      while (this.personneMoraleData.length > 0) {
        this.personneMoraleData.removeAt(0);
      }
      this.hiddenPersonPm = [];
      this.showPersonLinePm = [];

      const firstPm = this.createItem('pm');
      this.personneMoraleData.push(firstPm);
      this.personneMoraleData.at(0).patchValue(savedPm[0], { emitEvent: false });
      this.hiddenPersonPm[0] = true;
      this.showPersonLinePm[0] = false;

      for (let i = 1; i < savedPm.length; i++) {
        const group = this.createItem('pm');
        this.personneMoraleData.push(group);
        this.personneMoraleData.at(i).patchValue(savedPm[i], { emitEvent: false });
        this.hiddenPersonPm[i] = true;
        this.showPersonLinePm[i] = false;
      }

      const emptyPm = this.createItem('pm');
      this.personneMoraleData.push(emptyPm);
      this.lineIndexPm = savedPm.length;
      this.hiddenPersonPm[this.lineIndexPm] = true;
      this.showPersonLinePm[this.lineIndexPm] = true;
      this.itemsPm = this.personneMoraleData;
    }

    // Restaurer le brouillon du formulaire PM si ouvert
    if (saved.pmFormOpen) {
      this.hiddenPersonPm[this.lineIndexPm] = false;
      if (saved.currentPmForm) {
        this.personneMoraleData.at(this.lineIndexPm).patchValue(saved.currentPmForm, { emitEvent: false });
      }
    }

    // Marquer les champs restaurés comme dirty pour éviter les faux positifs de validation
    for (let i = 0; i < this.personnePhysiqueData.length; i++) {
      this.markFilledControlsDirty(this.personnePhysiqueData.at(i));
    }
    for (let i = 0; i < this.personneMoraleData.length; i++) {
      this.markFilledControlsDirty(this.personneMoraleData.at(i));
    }
  }

  /**
   * Vérifie si le pays sélectionné est la France.
   * Utilisé dans le template pour conditionner la validation du code postal.
   */
  isFrance(item: any): boolean {
    return item.get('adresse_country').value === 'FR';
  }

  /**
   * Abonne le champ code postal aux changements de pays :
   * en France → pattern 5 chiffres, à l'étranger → pas de contrainte de format.
   */
  private setupCpLogic(group: FormGroup, countryField: string, cpField: string): void {
    group.get(countryField).valueChanges.subscribe(country => {
      const cpControl = group.get(cpField);
      if (country === 'FR') {
        cpControl.setValidators([Validators.required, Validators.pattern(/^\d{5}$/)]);
      } else {
        cpControl.setValidators([Validators.required]);
      }
      cpControl.updateValueAndValidity();
    });
  }

  /**
   * Marque comme dirty tous les contrôles du groupe ayant une valeur non vide.
   * Nécessaire après patchValue pour que checkFieldValidity n'affiche pas
   * d'erreur sur les champs restaurés depuis le localStorage.
   */
  private markFilledControlsDirty(group: any): void {
    if (!group || !group.controls) { return; }
    Object.keys(group.controls).forEach(key => {
      const val = group.controls[key].value;
      if (val !== null && val !== '' && val !== undefined) {
        group.controls[key].markAsDirty();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-g/app-form-g.component.ts